<header-bar title="Videos"></header-bar>
<div class="page-content">

  <div class="card" style="background-color: transparent!important;margin-bottom: 0; margin-top: 0;">
    <div class="content" style="margin-bottom: 6px; margin-top: 0">

      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="1"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/pectoral-machine.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Übungsausführung am Gerät
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="2"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/power-lifting.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Übungen für Zuhause / Freihantel
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="3"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/crunches.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Kurse
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

      <!--
      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="4"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/power-lifting.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Kurse 30 Minuten
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="5"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/energy.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Kurse 45 Minuten
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

      -->
      <div class="video-link-container"
           style="width: 100%; margin-top: 24px">

        <div class="video-link shadow-l rounded-2 d-flex"
             data-type="btnVideoCategory"
             data-video-category-id="4"
             style="width: 100%;background-color: white; padding: 12px">
          <div class="align-self-center" style="min-width: 40px">
            <img src="/assets/icons/routines/lotus-flower.svg" style="max-width: 32px;">
          </div>
          <div class="align-self-center font-weight-bolder">
            Affirmationen / Meditationen
          </div>
          <div class="ms-auto ps3- align-self-center text-center">
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>

      </div>

    </div>
  </div>

</div>
<main-menu active-item="videos"></main-menu>
